// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:where(.vuetify-styles) .v-color-picker-canvas {
  display: flex;
  position: relative;
  overflow: hidden;
  contain: content;
  touch-action: none;
  width: 100%;
}
:where(.vuetify-styles) .v-color-picker-canvas__dot {
  position: absolute;
  top: 0;
  left: 0;
  width: 15px;
  height: 15px;
  background: transparent;
  border-radius: 50%;
  box-shadow: 0px 0px 0px 1.5px rgb(255, 255, 255), inset 0px 0px 1px 1.5px rgba(0, 0, 0, 0.3);
}
@media (forced-colors: active) {
  :where(.vuetify-styles) .v-color-picker-canvas__dot {
    border-style: solid;
    outline: 2px solid highlight;
  }
}
:where(.vuetify-styles) .v-color-picker-canvas__dot--disabled {
  box-shadow: 0px 0px 0px 1.5px rgba(255, 255, 255, 0.7), inset 0px 0px 1px 1.5px rgba(0, 0, 0, 0.3);
}
:where(.vuetify-styles) .v-color-picker-canvas:hover .v-color-picker-canvas__dot {
  will-change: transform;
}`, "",{"version":3,"sources":["webpack://./node_modules/vuetify/lib/components/VColorPicker/VColorPickerCanvas.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,4FAA4F;AAC9F;AACA;EACE;IACE,mBAAmB;IACnB,4BAA4B;EAC9B;AACF;AACA;EACE,kGAAkG;AACpG;AACA;EACE,sBAAsB;AACxB","sourcesContent":[".v-color-picker-canvas {\n  display: flex;\n  position: relative;\n  overflow: hidden;\n  contain: content;\n  touch-action: none;\n  width: 100%;\n}\n.v-color-picker-canvas__dot {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 15px;\n  height: 15px;\n  background: transparent;\n  border-radius: 50%;\n  box-shadow: 0px 0px 0px 1.5px rgb(255, 255, 255), inset 0px 0px 1px 1.5px rgba(0, 0, 0, 0.3);\n}\n@media (forced-colors: active) {\n  .v-color-picker-canvas__dot {\n    border-style: solid;\n    outline: 2px solid highlight;\n  }\n}\n.v-color-picker-canvas__dot--disabled {\n  box-shadow: 0px 0px 0px 1.5px rgba(255, 255, 255, 0.7), inset 0px 0px 1px 1.5px rgba(0, 0, 0, 0.3);\n}\n.v-color-picker-canvas:hover .v-color-picker-canvas__dot {\n  will-change: transform;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
